// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"P8-z"};